export function sanitizeUrl(url: string): string {
  return url
    .replace(/\/\//, '/')
    .replace(/\/$/, '')
    .replace(/\/index$/, '');
}
